import React, { useEffect, useState } from "react";
import PageTitle from "Components/PageTitle/PageTitle";
import MuiPaper from "Components/MuiPaper/MuiPaper";
import Grid from "@material-ui/core/Grid";
import { read } from "Helpers/LocalStorage";
import { useDispatch } from "react-redux";
import { getAllDasteProfile, setNameForSearchProfileCategory, setNameForSearchProfileTypeColor } from "Stores/actions";
import DasteProfile from "./components/DasteProfile/DasteProfile";
import TypeColorProfile from "./components/TypeColorProfile/TypeColorProfile";
import ProfileTable from "./components/ProfileTable";
import ChangeGroupPrice from "./components/ChangeGroupPrice";
import ArchiveDasteProfile from "./components/ArchiveDasteProfile/ArchiveDasteProfile";
import TypeColorSetting from "./components/TypeColorSetting/TypeColorSetting";
import BackDropLoading from "Components/BackDropLoading/BackDropLoading";
import Translator from "Languages/Utility/Translator";

function Profile() {
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();

  useEffect(() => {
    (async () => {
      try {
        setLoading(true);
        dispatch(setNameForSearchProfileCategory(""));
        dispatch(setNameForSearchProfileTypeColor(""));
        const params = {
          KeyGroup: read("groupKey"),
          KeyUser: read("userKey"),
        };
        await dispatch(getAllDasteProfile(params));
        setLoading(false);
      } catch (err) {
      console.error('[catch error]', err)
    }
    })();
  }, []);

  return (
    <>
      <BackDropLoading loading={loading} />
      <div className="page-top-title-button side-button my-2">
        <PageTitle title={<Translator id={"Profile"} />} />
        <div className="top-buttons">
          <div>
            {(read("addSeriProfileRules").accessRegister !== false) && <ArchiveDasteProfile />}
            {(read("typeColorRules") !== null && read("typeColorRules")?.accessShow !== false)  &&  <TypeColorSetting />}
          </div>
          <div>
            <ChangeGroupPrice />
          </div>
        </div>
      </div>
      <Grid container spacing={3}>
        <Grid item lg={3} md={4} sm={12} xs={12}>
          <Grid item className="secondaryPaper">
            <MuiPaper className="no-padding">
              <DasteProfile />
            </MuiPaper>
          </Grid>
          <Grid item className="secondaryPaper mt-3">
            <MuiPaper className="no-padding">
              <TypeColorProfile />
            </MuiPaper>
          </Grid>
        </Grid>
        <Grid item lg={9} md={8} sm={12} xs={12}>
          <MuiPaper>
            <ProfileTable />
          </MuiPaper>
        </Grid>
      </Grid>
    </>
  );
}

export default Profile;
